import { Link } from 'react-router';

import { DATA_AREAS } from '~/constants/data-areas';

import { useSearchHistoryTracker } from './use-search-history-tracker';

export type SearchHistoryStyles = {
  box: string;
  item: string;
  keyword: string;
  closeButton: string;
};

type Props = {
  styles: SearchHistoryStyles;
  closeButton: React.ReactNode;
  getParams?: (keyword: string) => URLSearchParams;
};

export const SearchHistory = ({ styles, closeButton, getParams }: Props) => {
  const { keywords, removeKeyword, addKeyword } = useSearchHistoryTracker();

  if (keywords.length === 0) {
    return null;
  }

  return (
    <ul className={styles.box} data-area={DATA_AREAS.SEARCH_HISTORY}>
      {keywords.map((keyword) => (
        <li className={styles.item} key={keyword}>
          <Link
            className={styles.keyword}
            to={{
              pathname: `${import.meta.env.VITE_CAMPAIGN_SEARCH_ROUTE}`,
              search: getParams ? `?${getParams(keyword).toString()}` : `?keyword=${keyword}`,
            }}
            onClick={() => addKeyword(keyword)}>
            {keyword}
          </Link>
          <button className={styles.closeButton} aria-label="削除する" onClick={() => removeKeyword(keyword)}>
            {closeButton}
          </button>
        </li>
      ))}
    </ul>
  );
};
